import React from 'react'
import { EnvelopeIcon, BuildingOfficeIcon, UserGroupIcon } from '@heroicons/react/24/outline'
import useGlobalTheme from '../../../hooks/useGlobalTheme'

function KPICards({ stats }) {
	const theme = useGlobalTheme()
	const isLight = theme === 'light'

	const cardCls = isLight
		? 'bg-white rounded-2xl p-5 sm:p-6 border border-gray-200 shadow-sm hover:border-gray-300 transition-all duration-200'
		: 'bg-gray-800 rounded-2xl p-5 sm:p-6 border border-gray-700 hover:border-gray-600 transition-all duration-200'
	const labelCls = isLight
		? 'text-gray-500 text-sm font-medium mb-2'
		: 'text-gray-400 text-sm font-medium mb-2'
	const valueCls = isLight
		? 'text-gray-900 text-2xl sm:text-3xl font-bold'
		: 'text-white text-2xl sm:text-3xl font-bold'

	const kpiData = [
		{
			title: 'Sent Emails',
			value: stats?.totalSent || 0,
			icon: EnvelopeIcon,
			bgColor: isLight ? 'bg-blue-50' : 'bg-blue-500/10',
			iconColor: isLight ? 'text-blue-600' : 'text-blue-400',
			trend: stats?.sentTrend,
		},
		{
			title: 'Brokerages',
			value: stats?.totalBrokerages || 0,
			icon: BuildingOfficeIcon,
			bgColor: isLight ? 'bg-purple-50' : 'bg-purple-500/10',
			iconColor: isLight ? 'text-purple-600' : 'text-purple-400',
			trend: stats?.brokerageTrend,
		},
		{
			title: 'Recipients',
			value: stats?.totalRecipients || 0,
			icon: UserGroupIcon,
			bgColor: isLight ? 'bg-green-50' : 'bg-green-500/10',
			iconColor: isLight ? 'text-green-600' : 'text-green-400',
			trend: stats?.recipientsTrend,
		},
	]

	return (
		<div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
			{kpiData.map((kpi, index) => (
				<div key={index} className={cardCls}>
					<div className="flex items-start justify-between">
						<div className="flex-1">
							<p className={labelCls}>{kpi.title}</p>
							<p className={valueCls}>
								{kpi.value.toLocaleString()}
							</p>
						</div>
						<div className={`${kpi.bgColor} p-2.5 sm:p-3 rounded-xl`}>
							<kpi.icon className={`w-5 h-5 sm:w-6 sm:h-6 ${kpi.iconColor}`} />
						</div>
					</div>
				</div>
			))}
		</div>
	)
}

export default KPICards
